import React, { Component } from 'react';
import './ConfiguratorSection.css';
import { withTranslation } from 'react-i18next';

class ConfiguratorSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fullscreen: false
        };
    }

    render() {
        const hasFooter = !!this.props.footer;
        const stickyImage =
            this.props.stickyImage !== false && !hasFooter;

        if (hasFooter) {
            return (
                <div className="section has-image-footer">
                    <div className={"imageContainer" + (this.state.fullscreen ? " fullscreen" : "")}>
                        <div className="imageHolder">
                            <div className="image">
                                {this.props.image}
                            </div>
                        </div>
                    </div>
                    <div className="optionsScroll">
                        <div className="imageFooter">
                            {this.props.footer}
                        </div>
                        {this.props.children}
                    </div>
                    <div className="mobileFooterSpacer" aria-hidden="true" />
                </div>
            );
        }

        return (
            <div className={"section" + (stickyImage ? " has-sticky-image" : "")}>
                <div className={"imageContainer" + (stickyImage ? " sticky" : "") + (this.state.fullscreen ? " fullscreen" : "")}>
                    <div className="imageHolder">
                        <div className="image">
                            {this.props.image}
                        </div>
                        <div className="footer">{this.props.footer}</div>
                    </div>
                </div>
                {this.props.children}
                <div className="mobileFooterSpacer" aria-hidden="true" />
            </div>
        );
    }
}

export default withTranslation() (ConfiguratorSection);


// WEBPACK FOOTER //
// ./src/ConfiguratorSection.js